// The public support address, shown on the legal pages, Pricing, Help,
// Settings and the trial-expired screen. The one copy in the client; the
// server's is in server/config/siteConfig.js.
export const SUPPORT_EMAIL = 'claudeweidner2013+Support@gmail.com';
